var Base = require('_js/base'),
  ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function RegularCourse(settings) {
  var self = this;

  self.api = settings.removeApi;
  self.container = $(settings.element).closest('.course-row-location');
  self.$container = $(self.container);
  self.activeModal = ko.observable(false);
}

RegularCourse.prototype = new Base();

RegularCourse.prototype.cancelCourse = function() {
  this.activeModal(true);
};

RegularCourse.prototype.verifyCancelCourse = function() {
  this.activeModal(false);
  var self = this;
  APIHelper.post(
    this.api,
    undefined,
    function() {
      self.$container.slideUp();
    },
    function(data) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: course-row-location.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + data.responseText,
          'status: ' + data.status,
          'statusText: ' + data.statusText,
          'requestUrl: ' + this.api
        ]
      });
    }
  );
};

RegularCourse.prototype.closeModal = function() {
  this.activeModal(false);
};

function regularCourseModel() {
  var courses = $('[data-remove-api]');
  if (courses.get(0) !== undefined) {
    courses.each(function(i, course) {
      ko.applyBindings(
        new RegularCourse({
          removeApi: $(course).data('remove-api'),
          element: $(course).get(0)
        }),
        $(course).get(0)
      );
    });
  }
}

module.exports = regularCourseModel;
